import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

// material-ui
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';

// project imports
import useAuth from 'hooks/useAuth';
import { useGetMenuMaster } from 'api/menu';
import Copilot from 'assets/images/auth/copilot.jpg';

// icons
import SettingOutlined from '@ant-design/icons/SettingOutlined';
import { Stack } from '@mui/material';

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  width: 42,
  height: 42,
  borderRadius: theme.shape.borderRadius * 1.5,
  color: '#fff',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 4,
  transition: 'all 0.2s ease',
  background: 'transparent',

  '&:hover': {
    background: '#486684',
    backdropFilter: 'blur(6px)'
  }
}));

export default function NavUser() {
  const navigate = useNavigate();

  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  const { logout } = useAuth();
  const handleLogout = async () => {
    try {
      await logout();
      navigate(`/login`);
    } catch (err) {
      console.error(err);
    }
  };

  const handleNavigateAI = () => {
    navigate("/chat");
  };

  

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  return (
    <Stack
      spacing={2}
      sx={{
        py: 1.5,
        justifyContent: 'center',
        alignItems: "center",
        // borderTop: '2px solid',
        // borderTopColor: 'divider',
        background: '#2c3e50'
      }}
    >
      <IconButton
        size="small"
        sx={{
          width: 50,
          height: "auto",
          p: 0, // remove padding
          // border: '1px solid',
          // borderColor: 'primary.dark'
        }}
        onClick={handleNavigateAI}
      >
        <Box component="img" src={Copilot} alt="icon" sx={{ width: '100%', height: 'auto' }} />
      </IconButton>
      {/* Icon Button */}
      <StyledIconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
        <SettingOutlined style={{ fontSize: 22 }} />
      </StyledIconButton>

      {/* Menu */}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
        <MenuItem component={Link} to="#!" onClick={() => setAnchorEl(null)}>
          Profile
        </MenuItem>
        <MenuItem component={Link} to="#!" onClick={() => setAnchorEl(null)}>
          My Account
        </MenuItem>
      </Menu>
    </Stack>
  );
}
